import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Spade, Radio } from "lucide-react";

const navLinks = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/membership", label: "Membership" },
  { href: "/tournaments", label: "Tournaments" },
  { href: "/events", label: "Events" },
  { href: "/gallery", label: "Gallery" },
  { href: "/hall-of-fame", label: "Hall of Fame" },
  { href: "/leaderboard", label: "Leaderboard" },
  { href: "/live", label: "Live", isLive: true },
  { href: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 w-full z-50 bg-black/90 backdrop-blur-lg border-b border-white/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <Spade className="w-8 h-8 text-gold transition-transform group-hover:scale-110" />
            <span className="font-heading text-xl md:text-2xl text-white tracking-tight">
              <span className="text-gold">SMSC</span> Poker
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-body uppercase tracking-wider transition-all duration-300 flex items-center gap-1.5 ${
                  location.pathname === link.href
                    ? "text-gold"
                    : "text-white/70 hover:text-gold"
                } ${link.isLive ? "text-red-500 hover:text-red-400" : ""}`}
                data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.isLive && <Radio className="w-3 h-3" />}
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 text-white hover:text-gold transition-colors"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-lg border-t border-white/5">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-body uppercase tracking-wider transition-colors ${
                  location.pathname === link.href
                    ? "text-gold bg-white/5"
                    : "text-white/70 hover:text-gold hover:bg-white/5"
                } ${link.isLive ? "text-red-500 hover:text-red-400" : ""}`}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.isLive && <Radio className="w-3 h-3" />}
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
